"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  position: absolute;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  height: ", "px;\n  width: ", "px;\n\n  &:checked ~ span {\n    border-color: ", ";\n  }\n\n  &:checked ~ span > svg {\n    max-width: 1em;\n    max-height: 1em;\n    width: 100%;\n    display: block;\n  }\n\n  & ~ span {\n    position: relative;\n    top: 0;\n    left: 0;\n    margin: ", "px 0;\n    height: ", "px;\n    width: ", "px;\n    background-color: ", ";\n    border-radius: ", "px;\n    border: ", " ", ";\n    box-shadow: ", ";\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.8rem;\n  }\n\n  & ~ span > svg {\n    position: absolute;\n    max-width: 1em;\n    max-height: 1em;\n    width: 100%;\n    display: none;\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

exports["default"] = function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  return styled_components_1.css(_templateObject(), theme.spacing.unit * 3, theme.spacing.unit * 3, disabled ? theme.palette.border["default"] : theme.palette.primary["default"], theme.spacing.unit, theme.spacing.unit * 3, theme.spacing.unit * 3, disabled ? theme.palette.background.secondary : theme.palette.background["default"], theme.border.radius.medium, theme.border.solid["default"], theme.palette.border["default"], theme.shadows.boxShadow.input, disabled ? styled_components_1.css(_templateObject2(), bitcoincom_pkg_theme_1.colors.solid.ghost) : theme.palette.primary.text);
};